<template>
	<div>
		<div class="member">
			<div class="tips" v-if="tips">{{tips}}</div>
			<div class="table">
				<el-table :data="tableData" style="width: 100%" :key="tableDataKey">
					<div v-for="(item,index) in column" :key="index">
						<el-table-column fixed="left" v-if="item.type === 'index'" label="序号" align="center"
							type="index" width="50">
						</el-table-column>
						<el-table-column width="30px" v-else-if="item.type === 'move'">
							<template slot-scope="scope">
								<el-dropdown v-if="tableData.length>1" placement="bottom"
									@command="movePos($event,scope.$index)" trigger="click">
									<div class="move">
										<i class="el-icon-rank"></i>
									</div>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item command="top" v-if="scope.$index != 0">向上移动</el-dropdown-item>
										<el-dropdown-item command="bottom"
											v-if="scope.$index != tableData.length-1">向下移动</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</template>
						</el-table-column>
						<el-table-column v-else :prop="item.prop" :label="item.label" :width="item.width">
							<template slot-scope="scope">
								<div class="col-center">
									<span v-if="item.required"
										style="padding-right: 5px;color: red;padding-bottom: 15px;margin-left: -10px;">*</span>
									<!-- 下拉框 -->
									<el-select @change="feedback" :disabled="disabled || item.disabled" :multiple="!!item.multiple" collapse-tags
										v-if="item.type === 'select'" style="width: 100%;"
										:placeholder="item.placeholder || item.label" v-model="scope.row[item.prop]">
										<el-option :label="v[item.rangLabel]" :value="v[item.rangValue]"
											v-for="(v,i) in item.option"></el-option>
									</el-select>
									<!-- 单字表单多下拉框 -->
									<div class="select-composite flex-sb" v-else-if="item.type === 'select-composite'">
										<el-select @change="feedback" :disabled="disabled || s.disabled" v-for="(s,k) in item.composite"
											:style="{width:s.width}" :placeholder="s.placeholder || s.label"
											:multiple="!!s.multiple" collapse-tags v-model="scope.row[s.prop]">
											<el-option :label="v[s.rangLabel]" :value="v[s.rangValue]"
												v-for="(v,i) in s.option"></el-option>
										</el-select>
									</div>
									<div v-else-if="item.type === 'select-school'">
										<el-select  :disabled="disabled || item.disabled" @change="feedback" style="width: 100%;"
											v-model="scope.row[item.prop]" filterable remote reserve-keyword
											placeholder="输入查询所属院校" :remote-method="remoteMethod"
											:loading="universityLoading">
											<el-option v-for="schoolItem in universityOptions" :key="schoolItem.id"
												:label="schoolItem.name" :value="schoolItem.name">
											</el-option>
										</el-select>
									</div>
									<!-- 日期 -->
									<el-date-picker :disabled="disabled || item.disabled" @change="feedback" v-else-if="item.type === 'date'"
										style="width: 100%;" v-model="scope.row[item.prop]"
										:type="item.dateType || 'date'" value-format="yyyy-MM-dd"
										:placeholder="item.placeholder || item.label"
										:default-value="item.defaultValue || ''">
									</el-date-picker>
									<!-- 单选框 -->
									<el-radio-group :disabled="disabled || item.disabled" @input="feedback" v-model="scope.row[item.prop]"
										v-else-if="item.type === 'radio'">
										<el-radio v-for="(v,i) in item.option"
											:label="v[item.rangValue]">{{v[item.rangLabel]}}</el-radio>
									</el-radio-group>
									<!-- 文件上传 -->
									<upload :disabled="disabled || item.disabled" v-else-if="item.type === 'upload'" :limit="item.limit" :text="item.text"
										:localList="scope.row[item.prop]" :tips="item.tips || ''"
										:accept="item.accept || '.png,.jpg,.jpeg,.webp,.pdf,.doc,.docx,.xls,.xlsx'"
										@success="uploadSuccess($event,scope.$index,item.prop)">
									</upload>
									<!-- textarea -->
									<el-input :disabled="disabled || item.disabled" @blur="feedback" :style="{width:item.conWidth}" :show-word-limit="true"
										resize="none" v-else-if="item.type === 'textarea'" type="textarea"
										:rows="item.rows || 3" :placeholder="item.placeholder || item.label"
										v-model="scope.row[item.prop]">
									</el-input>
									<!-- 数字输入框 -->
									<el-input :disabled="disabled || item.disabled" @blur="feedback"
										v-else-if="item.type === 'input' && item.inputType === 'number'"
										:maxlength="item.maxlength || 300" v-model.number="scope.row[item.prop]"
										:placeholder="item.placeholder || item.label"></el-input>
									<!-- 普通输入框 -->
									<el-input :disabled="disabled || item.disabled" @blur="feedback" v-else :maxlength="item.maxlength || 300"
										:placeholder="item.placeholderArray && item.placeholderArray[scope.$index] ? item.placeholderArray[scope.$index] : item.placeholder || item.label"
										v-model="scope.row[item.prop]"></el-input>
								</div>
							</template>
						</el-table-column>

					</div>
					<el-table-column prop="address" fixed="right" label="操作" align="center" width="60px" v-if="!disabled">
						<template slot-scope="scope">
							<el-popconfirm icon="el-icon-info" icon-color="red" title="确定删除这一行吗？"
								@confirm="delItem(scope.$index)">
								<el-button type="text" slot="reference">删除</el-button>
							</el-popconfirm>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="add-member" v-if="!disabled && ((max && tableData.length < max) || !max)" @click="add">
				+{{addText}}
			</div>
		</div>
	</div>
</template>

<script>
	// 拖拽
	import Sortable from 'sortablejs'
	import upload from "../upload"
	import {
		getUniversityList
	} from '@/common/api/public.js'
	export default {
		name: '',
		props: {
			list: {
				type: Array,
				default () {
					return []
				}
			},
			column: {
				type: Array,
				default () {
					return []
				}
			},
			addText: {
				type: String,
				default: '添加团队成员'
			},
			max: {
				type: [String, Number],
				default: ''
			},
			tips: {
				type: String,
				default: ''
			},
			disabled: {
				type: Boolean,
				default: false
			}
		},
		watch: {
			list: {
				handler(v) {
					this.tableData = v
					this.$nextTick(() => {
						this.columnDrop()
					})
				},
				deep: true,
				immediate: true
			}
		},
		components: {
			upload
		},
		data() {
			return {
				tableDataKey: 0,
				sortable: null,
				tableData: [],
				addObject: {},
				universityLoading: false,
				universityOptions: [],
			}
		},
		created() {},
		mounted() {

		},
		methods: {
			// 添加项目成员
			add() {
				this.tableData.push(JSON.parse(JSON.stringify(this.addObject)))
				this.columnDrop()
			},
			// 删除项目成员
			delItem(index) {
				this.tableData.splice(index, 1)
				this.columnDrop()
				this.$emit('change', this.tableData)
			},
			// 移动
			movePos(type, index) {
				let i = index
				if (type == 'bottom') {
					i++
				}
				this.tableData.splice(i - 1, 1, ...this.tableData.splice(i, 1, this.tableData[i - 1]));
				this.$emit('change', this.tableData)
			},
			// 列拖拽
			columnDrop() {
				const wrapperTr = this.$el.querySelector('.el-table__body-wrapper tbody')
				this.sortable = Sortable.create(wrapperTr, {
					animation: 180,
					delay: 0,
					handle: '.move',
					onEnd: evt => {
						const movedItem = this.tableData.splice(evt.oldIndex, 1)[0]
						this.tableData.splice(evt.newIndex, 0, movedItem)
						this.tableDataKey++
						this.$emit('change', this.tableData)
						this.$nextTick(() => {
							this.columnDrop()
						})
					}
				})
			},
			// 附件相关
			uploadSuccess(files, index, filed) {
				console.log(files)
				this.tableData[index][filed] = files
				this.$emit('change', this.tableData)
			},
			feedback() {
				this.$emit('change', this.tableData)
			},
			// 查询高校
			async remoteMethod(query) {
				if (query !== '') {
					this.universityLoading = true;
					const {
						data
					} = await getUniversityList({
						key_words: query,
						per_page: 20
					})
					this.universityOptions = data.data
					this.universityLoading = false
					console.log(this.universityOptions, 1111111111)
				}
			},
		}

	}
</script>

<style lang="scss" scoped>
	.member {
		overflow-x: auto;
	}

	.tips {
		color: red;
		margin-top: -10px;
	}

	.member .table,
	.member .add-member {
		width: 100%;
		box-sizing: border-box;
	}

	.member {
		border-radius: 0.25rem;
		border: 1px solid #E3E7EC;
		padding: 1.25rem;
		margin-bottom: 1.875rem;

		.add-member {
			margin-top: 0.625rem;
			border-radius: 4px;
			border: 1px dashed #E3E7EC;
			text-align: center;
			cursor: pointer;
			color: #4389DF;
			text-align: center;
			padding: 1rem;
			font-size: 1rem;
		}
	}

	.move {
		cursor: pointer;
		padding: 0 10px;
		margin: 0 -10px;
	}

	@media screen and (max-width: 922px) {
		.member {
			overflow-x: auto;
		}

		.member .table,
		.member .add-member {
			width: 60rem;

		}
	}
</style>